//Include Both Helper File with needed methods

import ResetPasswordFields from "Components/organisms/forms/reset-password/types";
import { toast } from "react-toastify";

// action


/**
 * Returning a string means it fails and there is an error. 
 * @returns 
 */
export const resetPassword = async (values: ResetPasswordFields): Promise<boolean> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/reset-password`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                newPassword: values.newPassword,
                oldPassword: values.oldPassword
            })
        })


        if (res.ok) {
            toast.success("Password updated.")
            return true;
        } else {
            const data = await res.json();
            toast.error(data.message);
            return false
        }
    } catch (err: any) {
        toast.error("Something went wrong.");
        return false
    }
}

export const updateWillingToRelocate = async (value: boolean): Promise<boolean> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/profile/willing-to-relocate`, {
            credentials: 'include',
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                willingToRelocate: value
            })
        })

        if (res.ok) {
            toast.success("Profile updated.")
            return true
        }

        const data = await res.json()
        toast.error(data.message ?? "Failed to update profile.")
        return false
    } catch (err: any) {
        toast.error("Something went wrong.")
        return false
    }
}
